import React from 'react';

import { replaceAll } from '../../components/Base/mol_function';

export default class MediaBic extends React.Component {
  mediaRef;
  bicContainerRef;
  constructor(props) {
    super(props);
    this.mediaRef = React.createRef();
    this.bicContainerRef = React.createRef();
  }
  componentDidMount() {
    let bicMedia = this.props.media?.bic ?? false;
    let ean = this.props.ean;
    if (bicMedia) {
      /*
          let scriptWidgetQuelle = document.createElement("script");
          scriptWidgetQuelle.type = "text/javascript";
          scriptWidgetQuelle.src =
            "https://www.bic-media.com/mobile/js/DMRWidgetHTML5.js";
          scriptWidgetQuelle.onload = () => {

           
          };

          this.bicContainerRef.current.append(scriptWidgetQuelle);
          */

      let iframe = document.createElement('iframe');
      iframe.src =
        'https://www.bic-media.com/mobile/mobileWidget-jqm1.4.html?isbn=' +
        ean +
        '&' +
        'launcher=no&' +
        'layout=auto&' +
        'width=200&' +
        'height=450&' +
        'tabMode=yes&' +
        'widthPopUp=1200&' +
        'heightPopUp=700&' +
        'openFSIPN=no&' +
        'showExtraFacebookButton=no&' +
        'showTAFButton=no&' +
        'showExtraShopButton=no&' +
        'tellafriend=no&' +
        'buyButton=no';
      iframe.style = 'width: 100%; height=100%';
      /*
      iframe.onload = () => {
        setTimeout(() => {
          debugger;
          iframe.style.height = "100%";
        }, 1000);
      };
      */
      setTimeout(() => {
        iframe.style.height = '100%';
      }, 1000);
      this.bicContainerRef.current.append(iframe);
    }
  }

  render() {
    let bicStyle = {};
    let bicMedia = this.props.media?.bic ?? false;
    if (bicMedia) {
      bicStyle = { height: '500px' };
    }
    return (
      <div ref={this.mediaRef}>
        <div ref={this.bicContainerRef} style={bicStyle}></div>
      </div>
    );
  }
}
